import React from "react"

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
  useTheme,
} from "@chakra-ui/core"

import MicrophoneSelect from "components/AudioRoom/MicrophoneSelect"
import { JoinAudioRoomDetails } from "components/AudioRoom/types"
import LocalTime from "components/LocalTime"

type TeacherJoinModalProps = {
  activeAcrClassPeriod: JoinAudioRoomDetails | null
  audioInputDevices: MediaDeviceInfo[]
  selectedAudioInputDeviceId: string
  setSelectedAudioInputDeviceId: (deviceId: string) => void
  microphoneError?: string
  onJoin: () => void
  joining: boolean
}

const TeacherJoinModal: React.FC<TeacherJoinModalProps> = ({
  activeAcrClassPeriod,
  audioInputDevices,
  selectedAudioInputDeviceId,
  setSelectedAudioInputDeviceId,
  microphoneError,
  onJoin,
  joining,
}) => {
  const theme: any = useTheme()

  return (
    <Modal isOpen isCentered closeOnOverlayClick={false} closeOnEsc={false}>
      <ModalContent>
        <ModalHeader>Join Class</ModalHeader>
        <ModalBody>
          {activeAcrClassPeriod ? (
            <Stack spacing="1">
              <Text>{activeAcrClassPeriod.acrClass.name}</Text>
              <Text>Subject: {activeAcrClassPeriod.acrClass.subject.name}</Text>
              <Text>
                <LocalTime omitDate timestamp={activeAcrClassPeriod.startsAt} />
                &nbsp;&mdash;&nbsp;
                <LocalTime omitDate timestamp={activeAcrClassPeriod.endsAt} />
              </Text>
            </Stack>
          ) : (
            <Text fontStyle="italic">No class currently in session</Text>
          )}
          <label htmlFor="audio-input-device">
            <Text mt="4">Microphone</Text>
          </label>
          <MicrophoneSelect
            audioInputDevices={audioInputDevices}
            selectedAudioInputDeviceId={selectedAudioInputDeviceId}
            setSelectedAudioInputDeviceId={setSelectedAudioInputDeviceId}
            disabled={joining}
          />
          {microphoneError && (
            <Text color="red.500" mt="2" role="alert">
              {microphoneError}
            </Text>
          )}
        </ModalBody>

        <ModalFooter justifyContent="center">
          <Button
            {...theme.buttonVariants.cloudroom}
            onClick={onJoin}
            isDisabled={Boolean(microphoneError) || joining}
            isLoading={joining}
            loadingText="Joining..."
            width="10rem"
          >
            Join
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default TeacherJoinModal
